/* eslint-disable react/no-danger */
import * as React from 'react';

import { prependUrlProtocolIfNone } from 'bundles/common/utils/urlUtils';
import { websitesInfo } from 'bundles/partners-graphql/constants';
import type { Instructor } from 'bundles/partners-graphql/types/Instructor';
import { clearEmptyFields, stringifyJsonLd } from 'bundles/seo/utils/utils';

type Props = {
  instructor: Instructor;
  description: string;
  pathname: string;
};

const WEBSITE_KEYS = ['website', 'websiteFacebook', 'websiteTwitter', 'websiteLinkedin'] as const;

const InstructorProfileGoogleSchemaMarkup = ({ instructor, description, pathname }: Props) => {
  const constructInstructorExternalLinks = () => {
    const { websites } = instructor;
    const instructorExternalLinks: Record<string, string> = {};

    WEBSITE_KEYS.forEach((key) => {
      const externalLinkInfo = websites?.[key] && websitesInfo[key];
      if (externalLinkInfo) {
        instructorExternalLinks[key] = prependUrlProtocolIfNone(`${externalLinkInfo.prefix}${websites?.[key]}`) || '';
      }
    });

    return instructorExternalLinks;
  };

  const markupJson = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    Name: `${instructor.fullName}, Instructor | Coursera`,
    url: `https://www.coursera.org${pathname}`,
    about: {
      '@id': `https://www.coursera.org${pathname}#instructor`,
      '@type': 'Person',
      name: `${instructor.fullName}`,
      description,
      image: `${instructor.photo}`,
      url: instructor.partners?.elements.map((partner: $TSFixMe) => partner.links.website),
      sameAs: Object.values(constructInstructorExternalLinks()),
    },
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: instructor.courses?.elements.map((course: $TSFixMe, i: $TSFixMe) => ({
        '@type': 'ListItem',
        position: i + 1,
        '@id': `https://www.coursera.org/learn/${course.slug}#mooc`,
        url: `https://www.coursera.org/learn/${course.slug}`,
      })),
    },
  };

  const createMarkup = () => ({
    __html: `
        <script type="application/ld+json">
          ${stringifyJsonLd(clearEmptyFields(markupJson))}
        </script>
      `,
  });

  return (
    <div className="rc-InstructorProfileGoogleSchemaMarkup">
      <div dangerouslySetInnerHTML={createMarkup()} />
    </div>
  );
};

export default InstructorProfileGoogleSchemaMarkup;
